// src/pages/Success.js
import React from "react";
import { Link, useLocation } from "react-router-dom";

export default function Success() {
  const location = useLocation();

  // Optional: session_id aus URL (falls du später etwas damit machen willst)
  const params = new URLSearchParams(location.search);
  const sessionId = params.get("session_id");

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-[#f6f3f2] flex items-center justify-center px-4">
      <div className="max-w-xl w-full bg-white rounded-2xl shadow-lg border border-gray-100 p-8 text-center">
        <h1 className="text-3xl font-extrabold text-green-700 mb-3">
          Vielen Dank für Ihre Bestellung!
        </h1>
        <p className="text-gray-700 mb-4 leading-relaxed">
          Ihre Zahlung war erfolgreich. Der GeoReport wird
          automatisch auf Basis Ihrer Angaben erzeugt und an Ihre E-Mail-Adresse
          geschickt.
        </p>
        <p className="text-sm text-gray-500 mb-6">
          In Einzelfällen kann der Versand wenige Minuten dauern. Bitte prüfen
          Sie gegebenenfalls auch Ihren Spam- bzw. Werbeordner.
        </p>

        {sessionId && (
          <p className="text-xs text-gray-400 mb-6">
            Referenz: <span className="font-mono">{sessionId}</span>
          </p>
        )}

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to="/report"
            className="inline-flex justify-center px-6 py-3 rounded-full bg-green-600 text-white font-semibold shadow-md hover:bg-green-700 transition text-sm"
          >
            Zurück zur Report-Seite
          </Link>
          <Link
            to="/"
            className="inline-flex justify-center px-6 py-3 rounded-full border border-gray-300 text-gray-700 font-medium hover:bg-gray-50 transition text-sm"
          >
            Zur Startseite
          </Link>
        </div>
      </div>
    </div>
  );
}
